import { useState } from "react";
import { X, Sparkles } from "lucide-react";

const retailers = [
  { name: "Amazon", href: "https://a.co/d/02CjmGgQ" },
  { name: "Apple Books", href: "https://books.apple.com/us/book/wrangling-chaos/id6759410633" },
  { name: "Barnes & Noble", href: "https://www.barnesandnoble.com/w/wrangling-chaos-dn-mccier/1149515587?ean=2940183582819" },
  { name: "Kobo", href: "https://www.kobo.com/us/en/ebook/wrangling-chaos" },
  { name: "Everand", href: "https://www.everand.com/book/1000550215/Wrangling-Chaos" },
  { name: "Smashwords", href: "https://www.smashwords.com/books/view/1972216" },
  { name: "Fable", href: "https://fable.co/book/x-9798232458454" },
];

export function LaunchBanner() {
  const [visible, setVisible] = useState(() => {
    return sessionStorage.getItem("launch-banner-dismissed") !== "true";
  });


  const dismiss = () => {
    setVisible(false);
    sessionStorage.setItem("launch-banner-dismissed", "true");
  };

  if (!visible) return null;

  return (
    <div className="relative bg-secondary text-secondary-foreground overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_50%,hsl(var(--brand-yellow)/0.15),transparent_50%),radial-gradient(circle_at_80%_50%,hsl(var(--brand-yellow)/0.15),transparent_50%)]" />
      <div className="container relative py-3 pr-10">
        <div className="flex flex-col items-center gap-2 text-center sm:gap-3">
          <div className="flex items-center gap-2 text-sm font-semibold sm:text-base">
            <Sparkles className="h-4 w-4 text-brand-yellow shrink-0" />
            <span>
              🎉 <span className="text-brand-yellow">Wrangling Chaos</span> is officially available!
            </span>
            <Sparkles className="h-4 w-4 text-brand-yellow shrink-0 hidden sm:block" />
          </div>
          <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-xs sm:text-sm text-secondary-foreground/70">
            <span className="font-medium text-secondary-foreground/50">Get it on:</span>
            {retailers.map((r, i) => (
              <span key={r.name} className="inline-flex items-center gap-1">
                <a
                  href={r.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline underline-offset-2 hover:text-brand-yellow transition-colors font-medium"
                >
                  {r.name}
                </a>
                {i < retailers.length - 1 && (
                  <span className="text-secondary-foreground/30">·</span>
                )}
              </span>
            ))}
          </div>
        </div>
      </div>
      <button
        onClick={dismiss}
        className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full p-1 text-secondary-foreground/50 hover:text-secondary-foreground hover:bg-secondary-foreground/10 transition-colors"
        aria-label="Dismiss banner"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
